import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowRightFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Button, Stack, Typography } from '@lyearn/ui';

import { buttonContainerStyles } from './styles';
import { SurveyCompleteContentProps } from './types';

const SurveyCompleteContentWeb: React.FC<SurveyCompleteContentProps> = (props) => {
  const { t } = useTranslation('SurveyEditor');
  const { className, onBack, backActionText, onNext, compact } = props;
  const onClick = useCallback(() => {
    onBack();
  }, [onBack]);

  return (
    <Stack alignItems="center" className={className} direction="col">
      <Typography color="text-text-primary" variant={compact ? 'heading-xs' : 'heading-l'}>
        {t('SurveyEditor:Completion.CompletionHeadline')}
      </Typography>
      <Typography
        className={compact ? 'mt-8' : 'mt-16'}
        color="text-text-paragraph"
        variant={compact ? 'body-short-02' : 'body-short-01'}>
        {t('SurveyEditor:Completion.CompletionDescription')}
      </Typography>
      <Stack
        className={compact ? 'mt-32 pb-8' : cn(buttonContainerStyles, 'pb-80')}
        gapX={8}
        justifyContent="center">
        <Button variant="outlined" onClick={onClick}>
          {backActionText}
        </Button>
        {onNext && (
          <Button EndIcon={ArrowRightFill} onClick={onNext}>
            {t('Common:NextContent')}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default SurveyCompleteContentWeb;
